import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  customer: Yup.object().shape({
    data: Yup.object().nullable().required('Customer Name is required'),
  }),
  location: Yup.object().shape({
    id: Yup.string().nullable().required('Location is required'),
  }),
  requestDate: Yup.date().nullable().required('Request Date is required'),
  requestTime: Yup.date().nullable().required('Request Time is required'),
  scheduleDate: Yup.date().nullable().required('Schedule Date is required'),
  scheduleTime: Yup.date().nullable().typeError('Schedule Time is invalid'),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
